module.exports = "<div *ngIf=\"loading\" id=\"linear-loader\" class=\"linear-loader\"> <!--TODO check if loader already displays-->\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n</div>\n<ng-content></ng-content>\n<div class=\"backdrop\" [ngClass]=\"getLoadingClass()\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/loading/linear/loading.linear.template.html
// module id = 1024
// module chunks = 0